import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Vacancy, VacancyCandidate } from '../../core/models';
import CustomEncoder from '../../core/helpers/custom-encoder';

@Injectable()
export class PublicService {
	url: string = environment.url;

	constructor(
		private http: HttpClient
	) { }

	getCandidatesBySchedule(vacancyId, scheduleId, token): Observable<any> {
		return this.http.get<any>(`${this.url}/public/vacancies/${vacancyId}/schedules/${scheduleId}/candidates`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	getSchedule(vacancyId, scheduleId, token): Observable<any> {
		return this.http.get<any>(`${this.url}/public/vacancies/${vacancyId}/schedules/${scheduleId}`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	setScheduleCandidateFeedback(vacancyId, scheduleId, candidateId, params = {}, token) {
		return this.http.post<any>(`${this.url}/public/vacancies/${vacancyId}/schedules/${scheduleId}/candidates/${candidateId}`, params, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	getVacancyById(vacancyId, token): Observable<Vacancy> {
		return this.http.get<Vacancy>(`${this.url}/public/vacancies/${vacancyId}`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	public getShortlistById(params: { vacancyId: string, stepId: string, shortlistId: string, token: string }): Observable<any> {
		return this.http.get<Vacancy>(`${this.url}/public/vacancies/${params.vacancyId}/steps/${params.stepId}/shortlists/${params.shortlistId}`, {
			headers: {
				Authorization: `Bearer ${params.token}`
			}
		});
	}

	getVacancyCandidate(vacancyId, vacancyCandidateId, token): Observable<VacancyCandidate> {
		return this.http.get<VacancyCandidate>(`${this.url}/public/vacancies/${vacancyId}/vacancy-candidates/${vacancyCandidateId}`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	resetPassword(params = {}, token): Observable<any> {
		return this.http.post<any>(`${this.url}/public/user-managers/reset-password`, params, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	getVacancyCandidatesFeedbackTests(vacancyId, testId, stepId, pagination, token) {
		let params = {
			pagination
		};

		let httpParams = new HttpParams({ encoder: new CustomEncoder() });

		for (const key of Object.keys(params)) {
			httpParams = httpParams.append(key, params[key] instanceof Object ? JSON.stringify(params[key]) : params[key]);
		}

		return this.http.get<any>(`${this.url}/public/vacancies/${vacancyId}/steps/${stepId}/tests/${testId}/feedback`, {
			params: httpParams,
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	// Feedback para candidatos.
	getVacancyCandidates(vacancyId, stepId, filterId, token, filter, candidates, pagination): Observable<any> {
		let params: any = {
			feedbackFilters: filter,
			pagination: pagination,
			candidates: candidates
		};

		let httpParams = new HttpParams({ encoder: new CustomEncoder() });

		for (const key of Object.keys(params)) {
			httpParams = httpParams.append(key, params[key] instanceof Object ? JSON.stringify(params[key]) : params[key]);
		}

		return this.http.get<any>(`${this.url}/public/vacancies/${vacancyId}/steps/${stepId}/filters/${filterId}/vacancy-candidates`, {
			params: httpParams,
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	public getShortlistVacancyCandidates(params: { vacancyId: string, stepId: string, shortlistId: string, searchFilter?: any, token: string, candidateIdsThatShouldBeIgnored: string, pagination: any }): Observable<any> {
		let data: any = {
			searchFilter: params.searchFilter || '',
			pagination: params.pagination,
			candidateIdsThatShouldBeIgnored: params.candidateIdsThatShouldBeIgnored
		};

		let httpParams = new HttpParams({ encoder: new CustomEncoder() });

		for (const key of Object.keys(data)) {
			httpParams = httpParams.append(key, data[key] instanceof Object ? JSON.stringify(data[key]) : data[key]);
		}

		return this.http.get<any>(`${this.url}/public/feedback/vacancies/${params.vacancyId}/steps/${params.stepId}/shortlist/${params.shortlistId}/vacancy-candidates`, {
			params: httpParams,
			headers: {
				Authorization: `Bearer ${params.token}`
			}
		});
	}

	public postShortlistVacancyCandidateFeedback(params: { vacancyId: string, stepId: string, shortlistId: string, candidateId: string, token: string, data: any }) {
		return this.http.post<any>(`${this.url}/public/feedback/vacancies/${params.vacancyId}/steps/${params.stepId}/shortlist/${params.shortlistId}/vacancy-candidates/${params.candidateId}`, params.data, {
			headers: {
				Authorization: `Bearer ${params.token}`
			}
		});
	}

	postVacancyCandidateFeedback(vacancyId, stepId, filterId, candidateId, params = {}, token: string) {
		return this.http.post<any>(`${this.url}/public/vacancies/${vacancyId}/steps/${stepId}/filters/${filterId}/vacancy-candidates/${candidateId}`, params, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	getVacancyCandidateRIStatus(vacancyId, userId, vacancyCandidateId, token) {
		return this.http.get<any>(`${this.url}/public/vacancy-candidate/internal-recruitment/${vacancyId}/${userId}/${vacancyCandidateId}/`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	postVacancyCandidateRIStatus(vacancyId, userId, vacancyCandidateId, status, params = {}, token: string) {
		return this.http.post<any>(`${this.url}/public/vacancy-candidate/internal-recruitment/${vacancyId}/${userId}/${vacancyCandidateId}/${status}`, params, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	public postExternalGuestAccess(params = {}, token: string) {
		return this.http.post<any>(`${this.url}/public/external-guest-access`, params, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}
}
